module.exports = __webpack_public_path__ + "static/BIL-64f597e9f0645cde7d77ee1c7985292c.mp4";